import { EXECUTE_ASSIGNMENT_ACTION } from '../../constants/actions/policies';

export function executeAssignmentAction(payload) {
    return {
        type: EXECUTE_ASSIGNMENT_ACTION,
        payload,
    };
}
